export default {"src":"/_next/static/media/apple-podcast-logo.d7c9cc95.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};